<template>
  <div>
    <b-row v-if="item && Object.keys(item).length" class="mx-md-0 p-md-3">
      <b-col cols="12" md="12">
        <b-row class="bg-white rounded-0">
          <b-col
            cols="12"
            md="12"
            class="p-3 d-flex align-items-start justify-content-between bg-white"
          >
            <AvatarInfo
              :downloadCode="pathOr(null, ['user', 'download_code'], item)"
              :title="pathOr(null, ['user', 'name'], item)"
              :description="pathOr(null, ['user', 'national_code'], item)"
              :genderId="pathOr(null, ['user', 'gender', 'id'], item)"
              :personCode="pathOr(null, ['user', 'person_code'], item)"
              :parvandehCode="pathOr(null, ['parvandeh', 'code'], item)"
            />
            <span
              v-text="pathOr('', ['ticket_status_id', 'caption'], item)"
              :class="`badge_style badge_style--${pathOr(
                'danger',
                ['ticket_status_id', 'color'],
                item
              )}`"
            />
          </b-col>
          <b-col md="12" cols="12" class="flex_between mb-3">
            <strong
              class="font_16 color_black"
              v-text="`${$lang.ticketLang.term}: `"
            />
            <span
              class="font_16 color_black"
              v-text="pathOr(null, ['parvandeh', 'term', 'caption'], item)"
            />
          </b-col>
          <b-col md="12" cols="12" class="flex_between mb-3">
            <strong
              class="font_16 color_black"
              v-text="`${$lang.ticketLang.parvandeh}: `"
            />
            <a
              class="font_16 color_primary"
              :href="goToParvandeh(item)"
              target="_blank"
              v-text="pathOr(null, ['parvandeh', 'parvandeh_number'], item)"
            />
          </b-col>
          <b-col md="12" cols="12" class="flex_between mb-3">
            <strong
              class="font_16 color_black"
              v-text="`${$lang.ticketLang.ticket_page.mobile_number}: `"
            />
            <span
              class="font_16 color_black"
              v-text="pathOr(null, ['user', 'mobile'], item)"
            />
          </b-col>
          <b-col
            v-if="showMoreInfo"
            md="12"
            cols="12"
            class="flex_between mb-3"
          >
            <strong
              class="font_16 color_black"
              v-text="`${$lang.ticketLang.ticket_page.ticket_number}: `"
            />
            <span
              class="font_16 color_black"
              v-text="pathOr(null, ['ticket_code'], item)"
            />
          </b-col>
          <b-col
            v-if="showMoreInfo"
            md="12"
            cols="12"
            class="flex_between mb-3"
          >
            <strong
              class="font_16 color_black"
              v-text="`${$lang.ticketLang.ticket_page.created_at}: `"
            />
            <span
              class="font_16 color_black dir_ltr"
              v-text="
                $moment(pathOr('', ['created_at', 'gregorian'], item)).format(
                  'jYYYY/jMM/jDD HH:mm'
                )
              "
            />
          </b-col>
          <b-col
            v-if="showMoreInfo"
            md="12"
            cols="12"
            class="flex_between mb-3"
          >
            <strong
              class="font_16 color_black"
              v-text="`${$lang.ticketLang.ticket_page.updated_at}: `"
            />
            <span
              class="font_16 color_black dir_ltr"
              v-text="
                $moment(pathOr('', ['updated_at', 'gregorian'], item)).format(
                  'jYYYY/jMM/jDD HH:mm'
                )
              "
            />
          </b-col>
          <b-col
            v-if="showMoreInfo"
            md="12"
            cols="12"
            class="flex_between mb-3"
          >
            <strong
              class="font_16 color_black"
              v-text="`${$lang.ticketLang.ticket_page.username}: `"
            />
            <span
              class="font_16 color_black"
              v-text="pathOr(null, ['user', 'username'], item)"
            />
          </b-col>
          <b-col
            v-if="showMoreInfo"
            md="12"
            cols="12"
            class="flex_between mb-3"
          >
            <strong
              class="font_16 color_black"
              v-text="`${$lang.ticketLang.ticket_page.unit}: `"
            />
            <span
              class="font_16 color_black"
              v-text="pathOr(null, ['ticket_unit_id', 'caption'], item)"
            />
          </b-col>
          <b-col
            v-if="showMoreInfo"
            md="12"
            cols="12"
            class="flex_between mb-3"
          >
            <strong
              class="font_16 color_black"
              v-text="`${$lang.last_login_time}: `"
            />
            <span
              class="font_16 color_black"
              v-html="
                createDateFormat(pathOr('', ['last_login', 'jalali'], item))
              "
            />
          </b-col>
          <b-col md="12" cols="12" class="text-center color_primary mb-3">
            <span
              v-if="showMoreInfo"
              class="cursor_pointer"
              @click="showMoreInfo = !showMoreInfo"
            >
              <mdicon name="minus" size="20" />
              <span class="font_14 ml-1" v-text="$lang.ticketLang.fewer_info" />
            </span>
            <span
              v-else
              class="cursor_pointer"
              @click="showMoreInfo = !showMoreInfo"
            >
              <mdicon name="plus" size="20" />
              <span class="font_14 ml-1" v-text="$lang.ticketLang.more_info" />
            </span>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import AvatarInfo from "@/components/global/AvatarInfo";
import { pathOr } from "ramda";
import { createDateFormat } from "@/shared/utils";

export default {
  name: "ticket-info-box",
  components: {
    AvatarInfo,
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      showMoreInfo: false,
    };
  },
  methods: {
    pathOr,
    createDateFormat,
    goToParvandeh(item) {
      const parvandeh_number = pathOr(
        null,
        ["parvandeh", "parvandeh_number"],
        item
      );
      const routerData = this.$router.resolve({
        name: "parvandeh_by_number",
        params: { parvandeh_number },
      });
      return routerData.href;
    },
  },
};
</script>
